import React, {useContext, useEffect, useState} from "react";
import Avatar from "../../../images/contactlogo.svg";
import Arrow from "../../../images/DownArrow.svg";
import {Tab, Tabs} from "@mui/material";
import {a11yProps, TabPanel} from "../../../styles/Tabs";
import OpenTickets from "./OpenTickets";
import SignalList from "./SignalList";
import Legends from "../asset/maps/ticketing/junctionDetails/Legends";
import MobileMap from "./Map";
import {useLazyQuery} from "@apollo/client";
import {GetTransformEmpDetails} from "./queries/queries";
import {
  GetTransformEmpDetailsResult,
  GetTransformEmpDetailsVar,
} from "./queries/types";
import {useLocation} from "react-router-dom";
import {AppContext} from "../../../context/context";
import {payloadTypes} from "../../../context/reducer";
import {CustomDrawerInMobile} from "../../../styles/CustomDrawerStyles";
import Profile from "./Profile";
import {handleSignOut} from "../../common/layout/Header";

const TicketingData = () => {
  const [value, setValue] = useState(0);
  const [showMap, setShowMap] = useState(false);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const [modal, setModal] = useState(false);

  async function generateAESKey(): Promise<CryptoKey> {
    return crypto.subtle.generateKey({name: "AES-GCM", length: 256}, true, [
      "encrypt",
      "decrypt",
    ]);
  }

  async function encryptWithAES(
    aesKey: CryptoKey,
    data: string
  ): Promise<{iv: string; ciphertext: string}> {
    const iv = crypto.getRandomValues(new Uint8Array(12));
    const encoded = new TextEncoder().encode(data);

    const ciphertext = await crypto.subtle.encrypt(
      {name: "AES-GCM", iv},
      aesKey,
      encoded
    );

    return {
      iv: btoa(String.fromCharCode(...iv)),
      ciphertext: btoa(String.fromCharCode(...new Uint8Array(ciphertext))),
    };
  }

  async function encryptAESKeyWithRSA(
    publicKeyPem: string,
    aesKey: CryptoKey
  ): Promise<string> {
    // Export AES key in raw format
    const rawKey = await crypto.subtle.exportKey("raw", aesKey);

    // Clean PEM to base64
    const cleaned = publicKeyPem
      .replace(/-----BEGIN PUBLIC KEY-----/, "")
      .replace(/-----END PUBLIC KEY-----/, "")
      .replace(/\s+/g, "");

    const binaryDerString = atob(cleaned);
    const binaryDer = new Uint8Array(
      [...binaryDerString].map((char) => char.charCodeAt(0))
    );

    // Import RSA public key
    const rsaKey = await crypto.subtle.importKey(
      "spki",
      binaryDer.buffer,
      {name: "RSA-OAEP", hash: "SHA-256"},
      false,
      ["encrypt"]
    );

    // Encrypt the AES key
    const encryptedKey = await crypto.subtle.encrypt(
      {name: "RSA-OAEP"},
      rsaKey,
      rawKey
    );

    return btoa(String.fromCharCode(...new Uint8Array(encryptedKey)));
  }

  // encryptPayload(rsaPublicKey, "Hello from frontend!").then(payload => {
  //   // Now send `payload` to your Go backend using fetch/axios
  // });
  return (
    <div className="mobile-ticketing">
      <div className="mobile-ticketing__header">
        <div>
          <img src={Arrow} alt="" className="mobile-ticketing__header--arrow" />
          <b>Ticketing</b>
        </div>
        <img
          src={Avatar}
          alt=""
          onClick={() => {
            setModal(true);
          }}
        />
      </div>
      <div className="mobile-ticketing__tabs">
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Raise Ticket" value={0} {...a11yProps(0)} />

          <Tab label="Open Tickets" value={1} {...a11yProps(1)} />
        </Tabs>
      </div>
      <div className="mobile-ticketing__tabpanel">
        <TabPanel value={value} index={0}>
          {/* <RaiseTicket /> */}
          <button
            className="p-2 m-2"
            onClick={() => {
              setShowMap(true);
            }}
          >
            Map
          </button>
          <button
            className="p-2 m-2"
            onClick={() => {
              setShowMap(false);
            }}
          >
            List
          </button>
          {showMap ? <MobileMap /> : <SignalList />}
          {/* <div className="mobile-raise-ticket__legends">
            <Legends />
          </div> */}
        </TabPanel>
        <TabPanel value={value} index={1}>
          <OpenTickets />
        </TabPanel>
      </div>
      <CustomDrawerInMobile
        anchor="bottom"
        open={modal}
        onClose={() => setModal(!modal)}
      >
        <Profile setModal={setModal} />
      </CustomDrawerInMobile>
    </div>
  );
};

const Ticketing = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const key = queryParams.get("key");

  if (key) localStorage.setItem("authToken", key);

  const {state, dispatch} = useContext(AppContext);

  const [error, setError] = useState<string | null>(null);

  const [getTransformEmpDetails, {data, loading}] = useLazyQuery<
    GetTransformEmpDetailsResult,
    GetTransformEmpDetailsVar
  >(GetTransformEmpDetails);

  useEffect(() => {
    if (key) {
      getTransformEmpDetails().then(({data, error}) => {
        if (data && data.GetTransformEmpDetails) {
          dispatch({
            type: payloadTypes.SET_CUST_ID,
            payload: {
              customerId: data.GetTransformEmpDetails.customerID,
            },
          });
          dispatch({
            type: payloadTypes.SET_EMP_ID,
            payload: {
              empId: data.GetTransformEmpDetails.id,
            },
          });
          dispatch({
            type: payloadTypes.SET_COMPANY_ID,
            payload: {
              companyId: data.GetTransformEmpDetails.companyID,
            },
          });
        }
        if (error?.message.includes("astram_uuid not found")) {
          localStorage.removeItem("authToken");
          handleSignOut();
        }
      });
    }
  }, [getTransformEmpDetails, key]);

  useEffect(() => {
    if ("geolocation" in navigator) {
      const watchId = navigator.geolocation.watchPosition(
        (position) => {
          let lon = position.coords.longitude;
          let longitude = parseFloat(lon.toFixed(4));

          let lat = position.coords.latitude;
          let latitude = parseFloat(lat.toFixed(4));

          if (state.longitude !== longitude && state.latitude !== latitude) {
            dispatch({
              type: payloadTypes.SET_LONGITUDE,
              payload: {
                longitude,
              },
            });

            dispatch({
              type: payloadTypes.SET_LATITUDE,
              payload: {
                latitude,
              },
            });
          }
        },
        (err) => {
          console.error("Geolocation error:", err);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );

      return () => navigator.geolocation.clearWatch(watchId);
    } else {
      setError("Geolocation is not supported by your browser.");
    }
  }, []);

  if (data && data?.GetTransformEmpDetails) {
    return <TicketingData />;
  } else {
    return <></>;
  }
};
export default Ticketing;
